// extracted by mini-css-extract-plugin
module.exports = {"content":"emptyIndicator_content__3Yhyw","label":"emptyIndicator_label__2lM-r"};